module.exports = __webpack_public_path__ + "e4a199ffd8b5a80574a1aeedeb716ecc.pdf";